export const getQueryParamsByName = (queryParamName: string) => {
    const urlParams = new URLSearchParams(window.location.search);
    const queryParam = urlParams.get(queryParamName);

    if (queryParam) {
        return queryParam;
    }
    return;
};

export const mapBrowserLocaleToJavaLocale = (locale: string, country = ''): string => {
    let localeString: string;
    if (country) {
        localeString = `${locale.split('-')[0]}_${country}`;
    } else {
        localeString = locale.replace('-', '_');
    }
    return localeString;
};
